/**
 * Inject styles into square-placement (Afterpay) shadow DOM
 * because external CSS cannot reach encapsulated content
 */
(function() {
  const STYLES = `
    .afterpay-text2, .afterpay-paragraph { font-size: 12px !important; }
    button.afterpay-logo.brand-afterpay, button.afterpay-logo.brand-afterpay svg { max-width: 40px !important; }
  `;

  function injectStyles(el) {
    try {
      if (el.shadowRoot) {
        let styleEl = el.shadowRoot.querySelector('style[data-afterpay-override]');
        if (!styleEl) {
          styleEl = document.createElement('style');
          styleEl.setAttribute('data-afterpay-override', '');
          styleEl.textContent = STYLES;
          el.shadowRoot.appendChild(styleEl);
          return true;
        }
      }
    } catch (e) {
      /* shadow closed or inaccessible */
    }
    return false;
  }

  function processPlacements() {
    document.querySelectorAll('.hdt-mini-cart__imgtrust square-placement, square-placement').forEach(injectStyles);
  }

  function init() {
    processPlacements();
    var observer = new MutationObserver(function() {
      processPlacements();
    });
    observer.observe(document.body, { childList: true, subtree: true });
    setTimeout(processPlacements, 1500);
    setTimeout(processPlacements, 3500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
